import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * ClipboardCheck icon
 *
 * @category Files/Forms/Editing
 */
const ClipboardCheck = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.422 6.45c-.855-.842-2.108-.842-3.303-.878-1.014-.264-.64-1.685-1.628-2.143-.96-.48-1.511-.222-2.577-.293-1.667 0-6.135-.954-7.133 1.008-.258.41-.164 1.042-.586 1.311-.328.188-.82.13-1.206.153-1.757-.117-3.362 1.3-3.408 3.057-.012 4.638 0 11.209 0 15.543-.223 2.436.55 4.638 3.267 4.696h14.5c3.784-.328 3.023-4.064 3.081-7.016V8.852c.035-.539-.34-1.769-.855-2.249zm-13.68-1.662c.14-.27.573-.469 1.065-.48 2.12.011 4.826-.082 6.723.046.855.153.82.926.809 1.792 0 .586.035 1.43-.48 1.746-1.664.398-4.194.046-6.15.152-.855-.035-1.405.152-1.839-.363-.41-.762-.234-1.991-.187-2.776zm13.446 21.258c-.07.41-.2.785-.492 1.078-.516.515-1.336.562-2.062.562-3.618.035-7.238.082-10.857.082-1.078 0-2.214.211-3.268-.058-.645-.164-1.277-.563-1.558-1.172-.2-.445-.21-.948-.21-1.44V9.11c0-.457 0-.937.21-1.347.21-.422.62-.715 1.042-.926.703-.363 1.664-.527 2.226.024.433.433.468 1.148.878 1.616.469.539 1.289.586 2.003.586 1.816 0 3.643.012 5.458.023.527 0 1.054 0 1.558-.152s.972-.492 1.16-.984c.14-.363.128-.808.41-1.066.21-.199.515-.234.796-.246.761-.046 1.616.024 2.155.563.598.585.633 1.522.633 2.354 0 5.165 0 10.33-.012 15.496 0 .1.009.995-.07.995"
        />
        <path
          fill="currentColor"
          d="M18.657 15.834a.618.618 0 0 1 .873.873l-3.707 3.707a.62.62 0 0 1-.88-.006l-1.826-1.881a.618.618 0 1 1 .885-.86l1.39 1.43z"
        />
      </svg>
    );
  }
);

ClipboardCheck.displayName = 'ClipboardCheck';

export { ClipboardCheck };
